import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router'
import qs from 'qs'
import User from 'singletons/User'
import Logo from 'components/common/Logo'
import Loading from '@ui-components-3/ui/lib/components/Loading'
import { DASHBOARD, LOGIN } from 'constants/routing'
import GlobalEvents from 'singletons/GlobalEvents'

const SsoWelcome = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { access_token, refresh_token } = useMemo(
    () => qs.parse(location.search, { ignoreQueryPrefix: true }),
    [location.search],
  )

  const handleSsoTokens = async () => {
    try {
      await User.processSsoLogin({
        token: access_token,
        refreshToken: refresh_token,
      })
      navigate(DASHBOARD)
    } catch (e) {
      GlobalEvents.emit('ssoLogin', { status: 'error' })
      navigate(LOGIN)
    }
  }

  useEffect(() => {
    if (access_token && refresh_token) {
      handleSsoTokens()
    }
  }, [access_token, refresh_token])

  return (
    <div className="bg-primary-800 w-full h-full flex justify-center bg-[url('/public/bg_texture.png')] bg-center bg-cover bg-no-repeat">
      <div className="m-auto text-center">
        <Logo variant={'white'} className="w-96" />
        <h1 className="typography-h5 mt-6 text-neutral-900">Welcome</h1>
        <Loading className="text-neutral-900" />
      </div>
    </div>
  )
}

export default SsoWelcome
